<script setup lang="ts">
/*
 * Оверлей-подсказка для FileAttach: пока над формой тащат файл, накрывает её
 * область рамкой «Перетащите файл сюда». Некликабельный — drag-события идут
 * к элементам формы под ним. Состояние и выбор получателя — в useFormFileDrop.
 */
defineProps<{
  rect: { top: number, left: number, width: number, height: number } | null
}>()
</script>

<template>
  <Teleport v-if="rect" to="body">
    <div
      class="file-drop-overlay"
      :style="{
        top: `${rect.top}px`,
        left: `${rect.left}px`,
        width: `${rect.width}px`,
        height: `${rect.height}px`,
      }"
    >
      <div class="file-drop-overlay__frame d-flex flex-column align-center justify-center ga-3 pa-6">
        <VIcon icon="ri-upload-2-line" size="56" />
        <h4 class="text-h4 mb-0 text-center">
          Перетащите файл сюда
        </h4>
        <span class="text-body-1 text-medium-emphasis text-center">
          Отпустите, чтобы прикрепить файлы
        </span>
      </div>
    </div>
  </Teleport>
</template>

<style scoped lang="scss">
.file-drop-overlay {
  position: fixed;
  z-index: 3000;
  padding: 12px;
  border-radius: 8px;
  background-color: rgba(var(--v-theme-background), 0.85);
  backdrop-filter: blur(2px);
  pointer-events: none;
}

.file-drop-overlay__frame {
  block-size: 100%;
  border: 2px dashed rgb(var(--v-theme-primary));
  border-radius: 8px;
}
</style>
